
export enum UserRightEnum {
  READ = "READ",WRITE = "WRITE",NONE = "NONE"
}
